import { Date_toDateString } from "../../common/dateUtils";
import { CodeStatus, PermitCategory, PermitTypeFilter, WorkPermitSortProperty } from "../../common/enums";
import { UrlSearchParams_append } from "../../common/urlUtils";

type WorkPermitFilter = {
    statuses: CodeStatus[];
    categories: PermitCategory[];
    permitTypes: PermitTypeFilter[];
    harbourOffices: string[];
    departmentIds: number[];
    searchText: string;
    fromDate: Date;
    toDate: Date;
    userId: string | undefined;
    activePositionsOnly: boolean;

    sortProperty: WorkPermitSortProperty | undefined;
    isDescending: boolean;

    pageSize: number;
    pageIndex: number;

    ignoreReducedDetail: boolean;
    
    handler: string;
};

export default WorkPermitFilter;

export function WorkPermitFilter_toURLSearchParams(workPermitFilter: WorkPermitFilter): URLSearchParams {
    const queryParameters = new URLSearchParams();

    UrlSearchParams_append(queryParameters, "statuses", workPermitFilter.statuses);
    UrlSearchParams_append(queryParameters, "categories", workPermitFilter.categories);
    UrlSearchParams_append(queryParameters, "permitTypes", workPermitFilter.permitTypes)
    UrlSearchParams_append(queryParameters, "harbourOffices", workPermitFilter.harbourOffices);
    UrlSearchParams_append(queryParameters, "departmentIds", workPermitFilter.departmentIds);
    UrlSearchParams_append(queryParameters, "searchText", workPermitFilter.searchText);
    UrlSearchParams_append(queryParameters, "fromDate", Date_toDateString(workPermitFilter.fromDate));
    UrlSearchParams_append(queryParameters, "toDate", Date_toDateString(workPermitFilter.toDate));
    UrlSearchParams_append(queryParameters, "sortProperty", workPermitFilter.sortProperty);
    UrlSearchParams_append(queryParameters, "isDescending", workPermitFilter.isDescending);
    UrlSearchParams_append(queryParameters, "pageSize", workPermitFilter.pageSize);
    UrlSearchParams_append(queryParameters, "pageIndex", workPermitFilter.pageIndex);
    UrlSearchParams_append(queryParameters, "ignoreReducedDetail", workPermitFilter.ignoreReducedDetail);
    UrlSearchParams_append(queryParameters, "userId", workPermitFilter.userId);
    UrlSearchParams_append(queryParameters, "activePositionsOnly", workPermitFilter.activePositionsOnly);

    return queryParameters;
}